import type { ApiOrgId } from '#/api/types/ApiTypedId';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

import type { OrgDashboardApiApiToken } from './types/OrgDashboardApiApiToken';

type ApiResponse = {
  apiTokens: OrgDashboardApiApiToken[];
  hasApi: boolean;
};

function mapResponse(data: ApiResponse) {
  return data;
}

const endpoint = new FetchEndpoint({
  urlFactory: (orgId: ApiOrgId) => `/data/orgdashboard/${orgId}/api-tokens`,
  mapResponse,
});

// Exports

export const orgDashboardApiIsomorphicFetchApiTokens =
  endpoint.createIsomorphicFetchFn();
